//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { useTheme } from 'styled-components';

import { IButtonStateStyles } from '@components/atoms/button/buttonStyles';

// TODO: PD-257587 - remove this hook
export const useOnboardingButtonStyles = (): IButtonStateStyles => {
  const theme = useTheme();

  return {
    fixed: {
      fontWeight: 'bold',
      borderShape: 'pill',
      borderThickness: 'thick',
    },
    standard: {
      color: theme.colors.white,
      backgroundColor: '#3D4CBF', // color only used while Vibe announcement is being shown
      borderColor: '#3D4CBF',
    },
    hover: {
      color: theme.colors.white,
      backgroundColor: '#303C98', // color only used while Vibe announcement is being shown
      borderColor: '#303C98',
    },
    active: {
      color: theme.colors.white,
      backgroundColor: '#242D72', // color only used while Vibe announcement is being shown
      borderColor: '#242D72',
    },
    disabled: {
      color: theme.colors.gray4,
      backgroundColor: theme.colors.gray0,
      borderColor: theme.colors.gray0,
    },
  };
};
